import { mergeClassNames } from "../../utils/classes";
import { getMarginClassName } from "../Button/button.helper";
import { getButtonGroupAlignClassName, getButtonGroupDirectionClassName } from "./buttonGroup.helper";

import type { Margin } from "../Button/button.types";
import type { ButtonGroupChildren, OneOrMore } from "./buttonGroup.helper";
import type { ButtonGroupAlign, ButtonGroupDirection } from "./buttonGroup.types";
import type { FC } from "react";

import * as styles from "./buttonGroup.module.scss";

interface ButtonGroupProps {
	children: OneOrMore<ButtonGroupChildren>;
	direction?: ButtonGroupDirection;
	align?: ButtonGroupAlign;
	stretch?: boolean;
	fillButtons?: boolean;
	padding?: boolean;
	margin?: Margin;
	wrap?: boolean;
}

export const ButtonGroup: FC<ButtonGroupProps> = ({
	children,
	direction,
	align,
	stretch,
	fillButtons,
	padding,
	margin,
	wrap = true,
}) => {
	const outerClassNames = mergeClassNames(
		stretch && styles.stretch,
		padding && styles.padding,
		margin && getMarginClassName(margin),
	);

	const classNames = mergeClassNames(
		styles.group,
		wrap && styles.wrap,
		stretch && styles.stretch,
		fillButtons && styles.fillButtons,
		direction && getButtonGroupDirectionClassName(direction),
		align && getButtonGroupAlignClassName(align),
	);

	return (
		<div className={outerClassNames}>
			<div className={classNames}>{children}</div>
		</div>
	);
};
